import { useStaticQuery, graphql } from "gatsby"

const useForm = () => {
  const query = useStaticQuery(graphql`
    query {
      allStrapiForm {
        nodes {
          strapiId
          nameForm
          nameEventForm
          uniqueReceiver
          interest_receiver {
            option
            receiver
          }
          interest_type {
            option
            type
          }
          redirectFormPage {
            name
            slug
          }
          name {
            name
            placeholder
          }
          email {
            name
            placeholder
          }
          phone {
            name
            placeholder
          }
          etiqueta {
            code
          }
          bodyForm {
            strapi_component
            name
            dropdownOptions {
              option
            }
            dropdownOptionsType {
              name
              interest_type {
                option
                type
              }
            }
            placeholder
            required
          }
          event {
            description
            name
            idEvent
            attendeeTypeId
            apiKey
            BuildingName
            BuildingUrl
            Items {
              name
              value
              tooltipItem
              wiseCode
            }
          }
        }
      }
    }
  `)

  return query
}
export default useForm
